module.exports = __webpack_public_path__ + "img/rating.ffd64c6f.png";